// @flow

import Game from '@/lib/game';
import UnitTemplates from '@/lib/unit_templates';

export default class {
  game: Game;

  constructor(game: Game) {
    this.game = game;
  }

  itemList() {
    return UnitTemplates.filter(template => Number.isInteger(template.price));
  }

  buy(
    unitTemplate: UnitTemplate
  ): { result: boolean, template?: UnitTemplate, message: ?string } {
    if (!this._validatePrice(unitTemplate)) {
      return { result: false, message: 'ゴールドが足りません' };
    }

    this.game.assetManager.reduceGold(unitTemplate.price || 0);
    this.game.assetManager.addUnit(unitTemplate);

    return {
      result: true,
      template: unitTemplate,
      message: `${unitTemplate.name} を購入しました`,
    };
  }

  _validatePrice(unitTemplate: UnitTemplate) {
    return this.game.assetManager.gold >= unitTemplate.price;
  }
}



// WEBPACK FOOTER //
// ./src/lib/shop/shop.js